import React, { Component } from 'react';

class IconTrash extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17.143" viewBox="0 0 15 17.143">
                <path id="Icon_awesome-trash-alt" data-name="Icon awesome-trash-alt" d="M1.071,15.536a1.607,1.607,0,0,0,1.607,1.607h9.643a1.607,1.607,0,0,0,1.607-1.607V4.286H1.071Zm9.107-8.571a.536.536,0,0,1,1.071,0v7.5a.536.536,0,0,1-1.071,0Zm-3.214,0a.536.536,0,0,1,1.071,0v7.5a.536.536,0,0,1-1.071,0Zm-3.214,0a.536.536,0,0,1,1.071,0v7.5a.536.536,0,0,1-1.071,0ZM14.464,1.071H10.446L10.132.445A.8.8,0,0,0,9.412,0H5.585a.794.794,0,0,0-.717.445l-.315.626H.536A.536.536,0,0,0,0,1.607V2.679a.536.536,0,0,0,.536.536H14.464A.536.536,0,0,0,15,2.679V1.607A.536.536,0,0,0,14.464,1.071Z" transform="translate(0 0)" fill="#1d53a5" />
            </svg>

        );
    }
}

export default IconTrash;